import {
  HIDE_ERROR,
  SET_ERROR_MSG,
  SET_ERROR_MSG_IN_MODAL,
  SHOW_ERROR,
  SHOW_ERROR_IN_MODAL,
} from './GlobalErrorComponent.constant';

const initialState = {
  visible: false,
  errorModalVisible: false,
};

const GlobalErrorComponentReducer = (state = initialState, action) => {
  switch (action.type) {
    case SHOW_ERROR:
      return { ...state, visible: true };
    case HIDE_ERROR:
      return { ...state, visible: false, errorMsg: null, errorModalVisible: false };
    case SET_ERROR_MSG:
      return { ...state, errorMsg: action.payload, visible: true };
    case SET_ERROR_MSG_IN_MODAL:
      return { ...state, errorMsg: action.payload, errorModalVisible: true };
    case SHOW_ERROR_IN_MODAL:
      return { ...state, errorModalVisible: true };
    default:
      return state;
  }
};

export default GlobalErrorComponentReducer;
